<template>
  <v-app>
    <transition name="scroll-y-transition" mode="out-in">
      <router-view :key="$route.fullPath" />
    </transition>
    <AppNavigationDrawer />
    <v-dialog :value="$store.get('app/showNotLoggedInModal')" max-width="290">
      <NotLoggedInModal v-if="$store.get('app/showNotLoggedInModal')" />
    </v-dialog>
    <v-dialog :value="$store.get('app/showErrorModal')" max-width="290">
      <ErrorModal v-if="$store.get('app/showErrorModal')" />
    </v-dialog>
  </v-app>
</template>

<script>
import NotLoggedInModal from '@/components/NotLoggedInModal'
import ErrorModal from '@/components/ErrorModal'
import gql from 'graphql-tag'
import AppNavigationDrawer from '@/components/AppNavigationDrawer'

export default {
  name: 'App',

  components: {
    NotLoggedInModal,
    ErrorModal,
    AppNavigationDrawer
  },

  async created() {
    const userId = this.$store.get('user/data@id')
    if (!userId) return
    const { data } = await this.$apollo.mutate({
      mutation: gql`
        mutation updateToken($input: UserInput!) {
          updateToken(input: $input) {
            token
          }
        }
      `,
      variables: {
        input: {
          id: userId
        }
      }
    })

    this.$store.dispatch('user/setToken', data.updateToken.token)
  }
}
</script>
